import { io } from 'socket.io-client';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL

const socket = io(SOCKET_URL, {
  reconnectionAttempts: 5,
  timeout: 2000,
  autoConnect: false,
  transports: ['websocket'], // Optional: you can add 'polling' as fallback if needed
});

export default socket;
